import type { PaymentMethod } from '@/types/pos';

/** Methods that never ask for a transaction reference at checkout. */
const REFERENCE_NOT_REQUIRED: ReadonlySet<PaymentMethod> = new Set<PaymentMethod>([
  'CASH',
  'CREDIT',
  'GIFT_CARD',
  'QR_CODE',
  'CHEQUE',
  // POS-I261: bank transfer reference stays optional (stored when typed, null when not).
  'BANK_TRANSFER',
]);

/** True when the checkout must block submission until a reference is typed. */
export function paymentNeedsReference(method: PaymentMethod): boolean {
  return !REFERENCE_NOT_REQUIRED.has(method);
}
